export default __webpack_public_path__ + "static/media/doc.cde2a718.svg";